import { api } from '../client';

export interface Company {
  id: string;
  name: string;
  displayName: string;
  slug: string;
  type: 'PRIMARY_ENTERPRISE' | 'PARTNER';
  status: 'ACTIVE' | 'INACTIVE' | 'SUSPENDED' | 'PENDING_VERIFICATION';
  registrationNumber?: string;
  parentCompanyId?: string;
  parentCompany?: { id: string; name: string; displayName: string };
  settings?: Record<string, unknown>;
  billingInfo?: Record<string, unknown>;
  address?: Record<string, unknown>;
  contact?: Record<string, unknown>;
  enabledPlugins?: string[];
  _count?: {
    users: number;
    childCompanies: number;
  };
  createdAt: string;
  updatedAt: string;
}

export interface CreateCompanyDto {
  name: string;
  displayName: string;
  slug: string;
  type: 'PRIMARY_ENTERPRISE' | 'PARTNER';
  status?: 'ACTIVE' | 'INACTIVE' | 'SUSPENDED' | 'PENDING_VERIFICATION';
  registrationNumber?: string;
  parentCompanyId?: string;
}

export interface QueryCompanyParams {
  search?: string;
  type?: 'PRIMARY_ENTERPRISE' | 'PARTNER';
  status?: 'ACTIVE' | 'INACTIVE' | 'SUSPENDED' | 'PENDING_VERIFICATION';
  page?: number;
  limit?: number;
}

export const companiesApi = {
  async getAll(params?: QueryCompanyParams) {
    const response = await api.get<{
      data: Company[];
      meta: { total: number; page: number; limit: number; totalPages: number };
    }>('/companies', { params });
    return response.data;
  },

  async getById(id: string) {
    const response = await api.get<Company>(`/companies/${id}`);
    return response.data;
  },

  async create(data: CreateCompanyDto) {
    const response = await api.post<Company>('/companies', data);
    return response.data;
  },

  async update(id: string, data: Partial<CreateCompanyDto>) {
    const response = await api.patch<Company>(`/companies/${id}`, data);
    return response.data;
  },

  async delete(id: string) {
    const response = await api.delete<Company>(`/companies/${id}`);
    return response.data;
  },
};
